import React from 'react'
import injectSheet from 'react-jss'

import { Magnifier } from '../../icons/actionIcons'

const ImageMagnifier = (props) => {
  const {
    classes,
    index = 0,
    openLightbox,
    elements,
    tip = 'Bild vergrössern',
  } = props

  const handleClick = (event) => {
    event.preventDefault()
    event.stopPropagation()

    openLightbox(elements)
  }

  return (
    <div className={`${classes.iconButtonContainer}`}>
      <div
        className={`${classes.iconButton}`}
        role="button"
        tabIndex={index}
        onClick={handleClick}
        onKeyDown={handleClick}
      >
        <Magnifier />
        {tip && (
          <div className={`${classes.tip}`}>{tip}</div>
        )}
      </div>
    </div>
  )
}

const styles = theme => ({
  iconButtonContainer: {
    opacity: 1,
    cursor: 'pointer',
    width: '30px',
    height: '30px',
    marginTop: '-8px',
    transition: [
      {
        property: 'opacity',
        duration: theme.speed.fast,
      },
    ],
  },
  iconButton: {
    position: 'relative',
    display: 'block',
    height: '100%',
    backgroundColor: theme.colors.main_2,
    borderRadius: '50%',
    transition: [
      {
        property: 'color',
        duration: theme.speed.fast,
      },
      {
        property: 'background-color',
        duration: theme.speed.fast,
      },
    ],
    '& svg': {
      padding: '5px',
      fill: theme.colors.secondary_3b,
    },
    '& $tip': {
      color: theme.colors.secondary_3b,
    },
    '&:hover': {
      backgroundColor: theme.colors.secondary_3a,
      '& $tip': {
        zIndex: 1,
        opacity: 1,
        transition: [
          {
            property: 'opacity',
            duration: theme.speed.medium,
            delay: theme.speed.fast,
          },
        ],
      },
    },
    '& > *': {
      width: '100%',
      height: '100%',
    },
  },
  tip: {
    position: 'absolute',
    padding: `2px ${theme.sizes.gutter / 2}px`,
    top: '-5px',
    left: '50%',
    transform: 'translate(-50%, -100%)',
    width: 'auto',
    whiteSpace: 'nowrap',
    fontSize: '0.5em',
    height: 'calc(0.5rem + 4px)',
    borderRadius: 'calc(0.25rem + 2px)',
    backgroundColor: theme.colors.secondary_3a,
    zIndex: -1,
    opacity: 0,
    transition: [
      {
        property: 'opacity',
        duration: theme.speed.fast,
        delay: 0,
      },
    ],
  },
})

export default injectSheet(styles)(ImageMagnifier)



// WEBPACK FOOTER //
// ./src/modules/core/components/imageMagnifier.jsx